import { Button } from '@skupreme/shared/ui';
import PermissionTooltip from '@components/PermissionTooltip';
import useUrlPermission from '@hooks/url-permission';

interface IAwaitAdminConfirmation {
  confirm: () => void;
  isAdmin: boolean;
}

export function AwaitAdminConfirmation({
  confirm,
  isAdmin,
}: IAwaitAdminConfirmation) {
  const { disabled, hidden } = useUrlPermission();
  return (
    <div className="sk:flex sk:flex-wrap sk:items-center sk:justify-between sk:gap-4 sk:p-4">
      <p className="sk:m-0 sk:max-w-88 sk:text-sm sk:text-fg">
        {isAdmin
          ? 'The purchase order is ready to be placed. Please click “Confirm” to issue the order to the supplier.'
          : 'The purchase order is ready to be issued. We’ve sent a notification to the workspace admin asking for confirmation.'}
      </p>
      <PermissionTooltip
        disabled={disabled}
        hidden={hidden}
        position="bottom right"
      >
        <Button
          variant="primary"
          isDisabled={!isAdmin || disabled}
          onPress={() => confirm()}
        >
          Confirm Purchase Order
        </Button>
      </PermissionTooltip>
    </div>
  );
}
